<template>
  <div class="home">
    <Header headertext="Ambiesoft" />
    <p id="error" v-if="error">{{error}}</p>
    <HistoryComponent :recentapps="recentapps" />
    <br />
    <AppsComponent
      v-bind:apps="appsData"
      v-bind:recentapps="recentapps"
    />
  </div>
</template>

<script>

// @ is an alias to /src
import Header from "@/components/Header.vue"
import AppsComponent from "@/components/AppsComponent.vue"
import HistoryComponent from "@/components/HistoryComponent.vue"


export default {
  name: "home",
  components: {
    Header,
    AppsComponent,
    HistoryComponent
  },
  props: ['appsData'],
  data: function() {
    return {
      error:''
    };
  },
  created() {
  },
  // Must this returns new value?
  computed: {
    

    // Returns first 5 apps, appsData is already sorted by date
    recentapps: function() {
      if(!this.appsData) return []
      
      console.log(this.appsData)
      var ret = []
      for(var app of this.appsData) {
        ret.push(app)
        if(ret.length >= 5)
          break;
      }
      return ret;
    }
  }
};
</script>

<style>
.home {
  text-align:center;
}
#error {
  color:red;
}
</style>